/**
 * studentRoutes — TabKey ↔ noms de route des trois onglets de l'espace élève.
 *
 * Les noms `home` et `tutor` sont ceux des onglets legacy (`studentTabScreens.js`) : un
 * `navigate("tutor")` écrit ailleurs dans l'app atterrit au même endroit des deux côtés de
 * l'interrupteur. `activities` est le seul nouveau.
 */
import { type TabKey } from "../../../../../design-system"

export type StudentTabKey = Extract<TabKey, "home" | "activities" | "tutor">

export const STUDENT_TAB_KEY_TO_ROUTE: Record<StudentTabKey, string> = {
    home: "home",
    activities: "activities",
    tutor: "tutor",
}

/** Le titre de chaque onglet : sur le web, celui de la page (`App.js` lit `headerTitle`). */
export const STUDENT_TAB_TITLES: Record<StudentTabKey, string> = {
    home: "Accueil",
    activities: "Activités",
    tutor: "Messages",
}

export function tabKeyToRouteName(key: TabKey): string | undefined {
    return (STUDENT_TAB_KEY_TO_ROUTE as Partial<Record<TabKey, string>>)[key]
}

export function routeNameToTabKey(routeName: string): StudentTabKey {
    const entry = Object.entries(STUDENT_TAB_KEY_TO_ROUTE).find(([, route]) => route === routeName)
    return (entry?.[0] as StudentTabKey | undefined) ?? "home"
}
